

































































import { Component, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import BusinessRulesModule from "@/store/modules/business-rules";
import { BusinessRulesState } from "@/models/business-rules/BusinessRulesState";
import { RulesConditions } from "@/models/business-rules/RulesConditions";
import { RulesMetrics } from "@/models/business-rules/RulesMetrics";
import { RulesOutcomePayload } from "@/models/business-rules/RulesOutcomePayload";
import { rulesOutcomeComparisons } from "@/helpers/business-rules/rule-outcome-comparisons";

const businessRules = namespace(BusinessRulesModule.name);

@Component({
  name: "RuleConditionsOutcome"
})

export default class RuleConditionsOutcome extends Vue {
  // ===== Store ===== //
  @State("businessRules") private readonly businessRules!: BusinessRulesState;
  @businessRules.Action("handleOutcomeAction") public handleOutcomeAction!: (action: string) => void;
  @businessRules.Action("handleOutcomeComparison") public handleOutcomeComparison!: (outcome: string) => void;
  @businessRules.Action("handleOutcomeMetricOne") public handleOutcomeMetricOne!: (metric: string) => void;
  @businessRules.Action("handleOutcomeMetricTwo") public handleOutcomeMetricTwo!: (metric: string | null) => void;

  // ===== Data ===== //
  public comparisons = rulesOutcomeComparisons;

  // ===== Methods ===== //

  // ===== Computed ===== //
  get actionMetric(): RulesMetrics {
    const filteredAction = this.businessRules.metricsList.filter(action => action.is_action);
    return {
      alias: filteredAction[0].alias,
      readable_name: filteredAction[0].readable_name
    };
  }
  get conditionMetrics(): RulesMetrics[] {
    return this.businessRules.metricsList.filter(metric => metric.is_condition);
  }
  get firstCondition(): boolean {
    return this.ruleConditions.length ? this.firstConditionComplete : false;
  }
  get firstConditionComplete(): boolean {
    return !!(this.ruleConditions &&
      this.ruleConditions.length &&
      this.ruleConditions[0].metric &&
      this.ruleConditions[0].comparison &&
      this.ruleConditions[0].value !== null
    );
  }
  get outcomeAction(): RulesMetrics {
    return this.actionMetric;
  }
  get outcomeComparison(): string {
    return this.rulesOutcome ? this.rulesOutcome.metric_comparison : "";
  }
  set outcomeComparison(newVal: string) {
    this.handleOutcomeComparison(newVal);
    this.handleOutcomeAction(this.actionMetric.alias);
  }
  get outcomeMetricsList(): RulesMetrics[] {
    return this.businessRules.metricsList.filter(metric => metric.is_outcome);
  }
  get outcomeMetricOne(): string {
    return this.rulesOutcome ? this.rulesOutcome.metric_1 : "";
  }
  set outcomeMetricOne(newVal: string) {
    this.handleOutcomeMetricOne(newVal);
  }
  get outcomeMetricTwo(): string | null {
    return this.rulesOutcome ? this.rulesOutcome.metric_2 : null;
  }
  set outcomeMetricTwo(newVal: string | null) {
    this.handleOutcomeMetricTwo(newVal);
  }
  get ruleConditions(): RulesConditions[] {
    return this.businessRules.currentSelectedConditions;
  }
  get rulesOutcome(): RulesOutcomePayload {
    return this.businessRules.rulesOutcome;
  }
}
